var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClapperSticks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 10,
    viewBox: "0 0 51 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.63768C0 2.07636 2.07636 0 4.63768 0H50.4348V9.85507H0V4.63768Z",
    fill: "#44A6EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53623 0L15.0725 0L20.2899 9.85507H12.7536L7.53623 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7101 0L27.2464 0L32.4638 9.85507H24.9275L19.7101 0Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8841 0L39.4203 0L44.6377 9.85507H37.1015L31.8841 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClapperSticks);
export default __webpack_public_path__ + "static/media/clapperSticks.1f6f2e8cad37805698733419bc534a21.svg";
export { ForwardRef as ReactComponent };